export const ALSDSeq = (parm) => {
    switch (parm) {
        case 1:
            return "P";
        case 2:
            return "R";
        case 3:
            return "S";
        case 4:
            return "W";
        case 5:
            return "A";
        case 6:
            return "N";
        case 7:
            return "C";
        case 8:
            return "L";
        default:
            return "P";
    }
}

export const ALSDComp = (param) => {
    switch(param) {
        case 0:
            return "OFF";
        case 1:
            return "ON";
        case 2:
            return "<>";
        case 3:
            return ">";
        case 4:
            return "<";
        default:
            return "ON";
    }
}



